import { useTranslation } from "react-i18next"

import styles from "../styles/file-viewer.module.css"

/**
 * Shown when a citation names a library but no delivered document answers to
 * it. Distinct from "preview unavailable": there is no source to fetch, so the
 * pane must say the link failed rather than imply a fetch that never happened.
 * The detail line carries why, because the heading alone reads as a broken
 * viewer rather than a claim the answer could not support.
 */
export function UnresolvedSourceViewer() {
  const { t } = useTranslation()

  return (
    <div className={styles.fallbackViewer}>
      <h2>{t("analysispanel.unresolved_citation")}</h2>
      <p>{t("analysispanel.unresolved_citation_detail")}</p>
    </div>
  )
}
